"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getARIAProps = void 0;
var tslib_1 = require("tslib");
function getARIAProps(props) {
    var e_1, _a;
    var ariaProps = {};
    try {
        for (var _b = tslib_1.__values(Object.entries(props)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = tslib_1.__read(_c.value, 2), propName = _d[0], propValue = _d[1];
            if (propName.startsWith("aria-")) {
                ariaProps[propName] = propValue;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return ariaProps;
}
exports.getARIAProps = getARIAProps;
//# sourceMappingURL=get-aria-props.js.map